import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/document-types/list/all?nocache="${new Date().getTime()}`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/document-types/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/document-types/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/document-types/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/document-types/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/document-types/delete/${id}`)
    },
}